import { config } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { useChannelChatVisibility } from '@/features/msg-channels/common/msg-channels.query';

import { SettingsSection } from '../settings-section';

export const ChannelChatVisibilitySetting = observer(() => {
  const setVisible = useChannelChatVisibility();
  return (
    <SettingsSection.Item>
      <SettingsSection.ItemHeader>
        <SettingsSection.ItemLabel>
          Show IM channel chats
        </SettingsSection.ItemLabel>
        <SettingsSection.ItemDescription>
          Show channel conversations and their subagent chats in Chats, with an
          IM badge.
        </SettingsSection.ItemDescription>
      </SettingsSection.ItemHeader>
      <SettingsSection.Switch
        aria-label="Show IM channel chats"
        checked={config.chat.show_messaging_channel_chats}
        onCheckedChange={setVisible}
      />
    </SettingsSection.Item>
  );
});
